<template>
  <div class="wg-row">
    <w-g-list
        :pagination="false"
        :fieldInit="field"
        :directionInit="direction"
        :keyField="'id'"
        :sortingFunctionGenerator="sortingFunctionGenerator"
        :headerItems="headerItems"
        :itemsToDisplay="tableItems"
        :listStyle="{
          height: 'auto'
        }"
        @sorting-field-changed="sortingFieldChanged"
        @direction-changed="directionChanged"
    >
      <template v-slot:default="{element}">
        <task-bar 
          :taskData="element" 
          :view="'full'"
          @open-task="$emit('open-task', $event)"
        ></task-bar>
      </template>
    </w-g-list>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import WGList from '../../../../../world/spa/components/WGList.vue';
import TaskBar from '../task/TaskBar.vue';

export default {
  components: {
    WGList,
    TaskBar
  },
  props: {
    // Array di info aggregate
    tasksData: {
      type: Array,
      default: () => [],
    },
    sortingFunctionGenerator: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      field: this.$anm22.getCookie('tk_t_col') !== '' ? this.$anm22.getCookie('tk_t_col') : "deadline",
      direction: this.$anm22.getCookie('tk_t_dir') !== '' ? this.$anm22.getCookie('tk_t_dir') : "DESC",
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    headerItems() {
      return [
        {
          field: 'priority',
          label: this.$anm22.strLang(this.lang, 'Priority', 'Priorità'),
          class: 'wg-xs-1',
          // style: {justifyContent: 'center'},
          disabled: false,
        },
        {
          field: 'name',
          label: this.$anm22.strLang(this.lang, 'Name', 'Nome'),
          class: 'wg-xs-5',
          style: {justifyContent: 'center'},
          disabled: false,
        },
        {
          field: 'staff',
          label: this.$anm22.strLang(this.lang, 'Staff', 'Staff'),
          class: 'wg-xs-2',
          // style: {justifyContent: 'center'},
          disabled: true,
        },
        {
          field: 'status',
          label: this.$anm22.strLang(this.lang, 'Status', 'Stato'),
          class: 'wg-xs-2',
          style: {justifyContent: 'center'},
          disabled: false,
        },
        {
          field: 'deadline',
          label: this.$anm22.strLang(this.lang, 'Deadline', 'Scadenza'),
          class: 'wg-xs-2',
          style: {justifyContent: 'center'},
          disabled: false,
        },
      ];
    },
    tableItems() {
      return this.tasksData.map(tdata => {
        return {
          ...tdata,
          'list-metadata': {
            type: 'item',
          }
        }
      });
    }
  },
  methods: {
    sortingFieldChanged(field) {
      this.$anm22.setCookie('tk_t_col', field, 31536000);
    },
    directionChanged(direction) {
      this.$anm22.setCookie('tk_t_dir', direction, 31536000);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>